// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"234":"preload","532":"styles"}[chunkId] + "." + {"234":"994d861e57721672c3f8","532":"b6e3e1ea357d2bc6972e"}[chunkId] + ".css";
};